import { Template } from "../../types";
import "./Template.css";
import { useEffect, useState } from "react";
import { themeColours } from "../../resources";
import { TemplateCard } from "./TemplateCard";
import { HiOutlineTemplate } from "react-icons/hi";
import api from "../../api";
import { Skeleton } from "@chakra-ui/react";

export function Templates() {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  function handleTemplateDelete(templateId: string) {
    setIsLoading(true);
    const newTemplates = templates.filter((temp) => temp.id !== templateId);
    setTemplates(newTemplates);
    setIsLoading(false);
  }

  useEffect(() => {
    const fetchTemplates = async function () {
      try {
        const res = await api.post("/account/template/get");
        const sortedTemplates = res.data.templates.sort((a: Template, b: Template) => {
          return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        });
        setTemplates(sortedTemplates);
        setIsLoading(false);
      } catch (e) {
        console.error("Error fetching templates");
      }
    };
    setIsLoading(true);
    fetchTemplates();
  }, []);

  if (isLoading) {
    return (
      <div className="pageContainer">
        <div className="templateContainer">
          <h1>My templates</h1>
          <div className="tempLoadContainer">
            <Skeleton height="30vh" width={"97%"} borderRadius={"16px"} />
            <Skeleton height="30vh" width={"97%"} borderRadius={"16px"} />
            <Skeleton height="30vh" width={"97%"} borderRadius={"16px"} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pageContainer">
      <div className="templateContainer">
        <h1>My templates</h1>
        {templates.length > 0 ? (
          templates.map((template) => <TemplateCard {...template} handleTemplateDelete={handleTemplateDelete} />)
        ) : (
          <div className="emptyTemplatePage">
            <HiOutlineTemplate color={themeColours.tertiary} size={25} />
            <text>Your templates are empty</text>
          </div>
        )}
      </div>
    </div>
  );
}
